import { home } from "./zn/home";
import { login } from "./zn/login";
import { module } from "./zn/module";
import {help,help2} from "./zn/help"
import { common } from "./zn/common"
export default {
  lang: "EN",
  home: home,
  login: login,
  module: module,
  help:help,
  help2:help2,
  common: common,
};
